var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var plugin = require('tailwindcss/plugin');

var merge = require('lodash.merge');

var castArray = require('lodash.castarray');

var uniq = require('lodash.uniq');

var styles = require('./styles');

var _require = require('./utils'),
    isUsableColor = _require.isUsableColor;

var computed = {// Reserved for future "magic properties", for example:
  // bulletColor: (color) => ({ 'ul > li::before': { backgroundColor: color } }),
};

function configToCss() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return merge.apply(void 0, [{}].concat(_toConsumableArray(Object.keys(config).filter(function (key) {
    return computed[key];
  }).map(function (key) {
    return computed[key](config[key]);
  })), _toConsumableArray(castArray(config.css || {}))));
}

module.exports = plugin.withOptions(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      modifiers = _ref.modifiers,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'prose' : _ref$className;

  return function (_ref2) {
    var addComponents = _ref2.addComponents,
        theme = _ref2.theme,
        variants = _ref2.variants;
    var DEFAULT_MODIFIERS = ['DEFAULT', 'sm', 'lg', 'xl', '2xl'].concat(_toConsumableArray(Object.entries(theme('colors')).filter(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          color = _ref4[0],
          values = _ref4[1];

      return isUsableColor(color, values);
    }).map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
          color = _ref6[0];

      return color;
    })));
    modifiers = modifiers === undefined ? DEFAULT_MODIFIERS : modifiers;
    var config = theme('typography');
    var all = uniq(['DEFAULT'].concat(_toConsumableArray(modifiers), _toConsumableArray(Object.keys(config).filter(function (modifier) {
      return !DEFAULT_MODIFIERS.includes(modifier);
    }))));
    addComponents(all.map(function (modifier) {
      return _defineProperty({}, modifier === 'DEFAULT' ? ".".concat(className) : ".".concat(className, "-").concat(modifier), configToCss(config[modifier]));
    }), variants('typography'));
  };
}, function () {
  return {
    theme: {
      typography: styles
    },
    variants: {
      typography: ['responsive']
    }
  };
});